module.exports = new __parcel__URL__("concentration.7d597663.svg").toString();